export default {"src":"/_next/static/media/icon_thumbsV2.e9078383.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};